import React, { useEffect } from "react"
import { HugoStateApi, useButton, useTemplateEngine } from "../hugo"
import contact from './contact.hugo'
import { useNavigate } from "react-router-dom"
import { Cell, Icon, Paper, Row, Wall, arrow1Icon, mailIcon, xingIcon } from "../ui"
import contactImg from "./assets/contact.png"

type Props = {
    hugoApi: HugoStateApi
}

const Contact: React.FC<Props> = ({ hugoApi }) => {
    const render = useTemplateEngine();
    const navigate = useNavigate()
    const [backButton] = useButton({
        label: '◄ Home',
        onClick: () => {
            navigate('/', { state: 'hugo' })
        },
        position: { x: 0, y: 0 },
        visible: true,
        condensed: true,
    })
    const [mailButton] = useButton({
        label: '✉ Mail',
        onClick: () => {
            window.location.href = "mailto: alexander@muehrenberg.de"
        },
        position: { x: 11, y: 0 },
        visible: true,
        condensed: true,
    })
    const [telephoneBotton] = useButton({
        label: '☎ Call',
        onClick: () => {
            window.location.href = "tel:+4915756692788"
        },
        position: { x: 22, y: 0 },
        visible: true,
        condensed: true,
    })

    useEffect(() => {
        setTimeout(() => { hugoApi.output(render(contact), { append: false, plugins: [backButton, mailButton, telephoneBotton] }) }, 100)
    }, [])

    return (
        <Wall>
            <Paper $rotate={-1}>
                <Row $height={1.8} $skewStrength={1.5} $hueRotate={-100} $contrast={100} $saturate={120} $brightness={100}>
                    <Cell $width={1.5}>
                        <img src={contactImg} style={{ width: '120%', margin: '0 -10%', opacity: 0.8}}/>
                        <p>

                        <a href="mailto:alexander@muehrenberg"><Icon src={mailIcon} /> <strong>Write a Mail</strong></a>
                        </p>
                    </Cell>
                </Row>
            </Paper>
            <Paper $rotate={7}>
                <Row $height={0.9} $skewStrength={0.5} $hueRotate={60} $contrast={100} $saturate={170} $brightness={95}>
                    <Cell $width={0.9}>
                        <h3 style={{ fontSize: '3rem' }}><Icon src={xingIcon} />ing</h3>
                        <p>
                            <a
                                href="https://www.xing.com/profile/Alexander_Muehrenberg"
                                target="_blank"
                                style={{
                                    transform: 'rotate(2deg)',
                                    marginLeft: '0em',
                                    marginTop: '1em',
                                    fontSize: '1.1em',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                }}
                            >
                                Open Profile <Icon src={arrow1Icon} />
                            </a>
                        </p>
                    </Cell>
                </Row>
            </Paper>
        </Wall>
    )
}

export default Contact